import React from 'react';
import { Spinner } from 'react-bootstrap';

const EstoqueItensTab = ({ estoque, handleOpenAdjustModal, handleMinimoChange }) => {

  const getStatusConfig = (item) => {
    const quantidade = item.quantidade_em_estoque;
    const minimo = item.estoque_minimo;

    if (quantidade <= 0) {
      return { label: 'Zerado', bg: '#fef2f2', color: '#dc2626', border: '#fecaca', dot: '#ef4444' };
    }
    if (quantidade <= minimo) {
      return { label: 'Baixo', bg: '#fffbeb', color: '#d97706', border: '#fde68a', dot: '#f59e0b' };
    }
    return { label: 'OK', bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0', dot: '#22c55e' };
  };

  if (!estoque || estoque.length === 0) {
    return (
      <div style={{
        textAlign: 'center', padding: '60px 24px',
        backgroundColor: '#fff', borderRadius: '12px',
        border: '1px solid #e5e7eb',
      }}>
        <svg width="48" height="48" fill="none" stroke="#d1d5db" viewBox="0 0 24 24" style={{ display: 'block', margin: '0 auto 16px' }}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
        <p style={{ margin: 0, fontSize: `calc(14px * var(--font-scale))`, color: '#9ca3af', fontFamily: "'Inter', 'Segoe UI', sans-serif" }}>
          Nenhum item de estoque encontrado.
        </p>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif" }}>
      <style>{`
        .estoque-table { width: 100%; border-collapse: collapse; }
        .estoque-table thead tr {
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          border-bottom: 2px solid #e2e8f0;
        }
        .estoque-table thead th {
          padding: 12px 16px; font-size: 11px; font-weight: 700;
          color: #64748b; text-transform: uppercase; letter-spacing: 0.5px;
          white-space: nowrap; font-family: 'Inter', 'Segoe UI', sans-serif;
        }
        .estoque-table tbody tr {
          border-bottom: 1px solid #f1f5f9; transition: background 0.15s;
        }
        .estoque-table tbody tr:hover { background: #f8fafc; }
        .estoque-table tbody td {
          padding: 12px 16px; font-size: calc(13px * var(--font-scale)) color: #374151;
          vertical-align: middle; font-family: 'Inter', 'Segoe UI', sans-serif;
        }
        .minimo-input {
          width: 80px; padding: 6px 10px; border-radius: 6px;
          border: 1px solid #e5e7eb; font-size: calc(13px * var(--font-scale)) color: #374151;
          text-align: center; font-family: 'Inter', 'Segoe UI', sans-serif;
          transition: border-color 0.15s, box-shadow 0.15s; outline: none;
        }
        .minimo-input:focus {
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59,130,246,0.1);
        }
        .ajustar-btn {
          padding: 6px 14px; border-radius: 6px; border: 1px solid #3b82f6;
          background: #eff6ff; color: #2563eb; font-size: 12px; font-weight: '600';
          cursor: pointer; transition: all 0.15s; font-family: 'Inter', 'Segoe UI', sans-serif;
          display: inline-flex; align-items: center; gap: 5px;
        }
        .ajustar-btn:hover { background: #dbeafe; }
      `}</style>

      {/* Resumo rápido */}
      <div style={{ display: 'flex', gap: '12px', marginBottom: '20px', flexWrap: 'wrap' }}>
        {[
          { label: 'Total de Itens', value: estoque.length, bg: '#eff6ff', color: '#2563eb', border: '#bfdbfe' },
          { label: 'Zerados', value: estoque.filter(i => i.quantidade_em_estoque <= 0).length, bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
          { label: 'Estoque Baixo', value: estoque.filter(i => i.quantidade_em_estoque > 0 && i.quantidade_em_estoque <= i.estoque_minimo).length, bg: '#fffbeb', color: '#d97706', border: '#fde68a' },
          { label: 'Status OK', value: estoque.filter(i => i.quantidade_em_estoque > i.estoque_minimo).length, bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0' },
        ].map(card => (
          <div key={card.label} style={{
            padding: '12px 16px', borderRadius: '10px',
            backgroundColor: card.bg, border: `1px solid ${card.border}`,
            minWidth: '120px', flex: '1',
          }}>
            <div style={{ fontSize: '22px', fontWeight: '700', color: card.color }}>{card.value}</div>
            <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600', color: card.color, opacity: 0.8, marginTop: '2px' }}>{card.label}</div>
          </div>
        ))}
      </div>

      {/* Tabela */}
      <div style={{
        backgroundColor: '#fff', borderRadius: '12px',
        border: '1px solid #e5e7eb', overflow: 'hidden',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
      }}>
        <table className="estoque-table">
          <thead>
            <tr>
              <th>Material</th>
              <th className="d-none d-md-table-cell">Fabricante</th>
              <th style={{ textAlign: 'center' }}>Estoque Atual</th>
              <th style={{ textAlign: 'center' }}>
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                  Estoque Mínimo
                  <span title="Referencial para o sistema alertar sobre a necessidade de reposição." style={{ cursor: 'help' }}>
                    <svg width="12" height="12" fill="none" stroke="#9ca3af" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </span>
                </span>
              </th>
              <th style={{ textAlign: 'center' }}>Status</th>
              <th style={{ textAlign: 'center' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {estoque.map((item) => {
              const status = getStatusConfig(item);
              return (
                <tr key={item.id}>
                  {/* Material */}
                  <td>
                    <div style={{ fontWeight: '600', color: '#111827' }}>
                      {item.tipo_material?.nome || 'N/A'}
                    </div>
                    {item.tipo_material?.unidade_medida && (
                      <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', marginTop: '1px' }}>
                        {item.tipo_material.unidade_medida}
                      </div>
                    )}
                  </td>

                  {/* Fabricante */}
                  <td className="d-none d-md-table-cell" style={{ color: '#6b7280' }}>
                    {item.fabricante || <span style={{ color: '#d1d5db', fontStyle: 'italic' }}>—</span>}
                  </td>

                  {/* Estoque Atual */}
                  <td style={{ textAlign: 'center' }}>
                    <span style={{
                      fontSize: '16px', fontWeight: '700',
                      color: item.quantidade_em_estoque <= 0 ? '#ef4444' : item.quantidade_em_estoque <= item.estoque_minimo ? '#f59e0b' : '#111827',
                    }}>
                      {item.quantidade_em_estoque}
                    </span>
                    {item.tipo_material?.unidade_medida && (
                      <span style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', marginLeft: '4px' }}>
                        {item.tipo_material.unidade_medida}
                      </span>
                    )}
                  </td>

                  {/* Estoque Mínimo (editável) */}
                  <td style={{ textAlign: 'center' }}>
                    <input
                      type="number"
                      className="minimo-input"
                      defaultValue={item.estoque_minimo}
                      onBlur={(e) => handleMinimoChange(item.id, e.target.value)}
                    />
                  </td>

                  {/* Status */}
                  <td style={{ textAlign: 'center' }}>
                    <span style={{
                      display: 'inline-flex', alignItems: 'center', gap: '5px',
                      padding: '3px 10px', borderRadius: '999px', fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600',
                      backgroundColor: status.bg, color: status.color, border: `1px solid ${status.border}`,
                    }}>
                      <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: status.dot, flexShrink: 0 }} />
                      {status.label}
                    </span>
                  </td>

                  {/* Ações */}
                  <td style={{ textAlign: 'center' }}>
                    <button
                      className="ajustar-btn"
                      onClick={() => handleOpenAdjustModal(item)}
                    >
                      <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                      </svg>
                      Ajustar
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EstoqueItensTab;
